export const getCanSave = (values) => {
  const { name, slogan, card, cover } = values || {};
  return !!name && !!slogan && !!card && !!cover;
};
